export default __webpack_public_path__ + "static/media/ball.8292826c.ogg";